export const LANG_FR = "fr";
export const LANG_EN = "en";

export const CONTENT_LANG_FR = "FRENCH";
export const CONTENT_LANG_EN = "ENGLISH";
